import React,{useEffect} from "react";
import BreadCrumb from "../Components/BreadCrumb";
import bgImg from '../Images/about-breadcrumb.webp';
import {
  FaHome,
  FaIndustry,
  FaGlobe,
  FaNewspaper,
  FaFileAlt
} from "react-icons/fa";
import { bentoniteDropdown, industrialMinerals } from "../Data";
import { blogs } from "../Blog";
import webPageSchema from "../Schema/WebPageSchema";
import SchemaMarkup from "../Components/SchemaMarkup";

const Sitemap=()=>{
      useEffect(() => {
                document.title =
                  "Sitemap | Iris Impulse India Pvt. Ltd.";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Access the Iris Impulse India Pvt. Ltd. website sitemap to quickly find pages for bentonite, industrial minerals, company details, and customer service support."
                  );
                }
            
                 const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://irisimpulse.com/sitemap");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Sitemap | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Access the Iris Impulse India Pvt. Ltd. website sitemap to quickly find pages for bentonite, industrial minerals, company details, and customer service support."
                );
              }
            
              const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://irisimpulse.com/sitemap");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/home.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Sitemap | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Access the Iris Impulse India Pvt. Ltd. website sitemap to quickly find pages for bentonite, industrial minerals, company details, and customer service support."
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/home.webp"
                );
              }
              }, []);

const webPageData = webPageSchema({
  url: "https://irisimpulse.com/sitemap",
  title: "Sitemap | Iris Impulse India Pvt. Ltd.",
  description: "Access the Iris Impulse India Pvt. Ltd. website sitemap to quickly find pages for bentonite, industrial minerals, company details, and customer service support.",
  image:"https://irisimpulse.com/Images/home.webp",
});
    return(
        <>
        <SchemaMarkup data={webPageData} />
         <BreadCrumb
  title="Sitemap" 
  bgImage={bgImg} 
/>

        <section className="sitemap-page">

      <div className="container">

        {/* PAGE TITLE */}
        <div className="sitemap-top">

          <h2 className="section-heading">
            Explore Iris Impulse India Pvt. Ltd.
          </h2>
        </div>

        {/* GRID */}
        <div className="sitemap-grid">

          {/* COLUMN 1 */}
          <div className="sitemap-column">

            <div className="sitemap-block">
              <h3>
                <FaHome />
                Iris Impulse India Private Limited
              </h3>

              <ul>
                <li><a href="/">Home</a></li>

                <li><a href="/about-us">About Us</a></li>

                <li>
                  <a href="/about-us/our-group-companies-team">
                    Our Group Companies & Team
                  </a>
                </li>

                <li>
                  <a href="/about-us/infrastructure">
                    Infrastructure
                  </a>
                </li>

                <li>
                  <a href="/about-us/research-quality">
                    Research & Quality
                  </a>
                </li>

                <li>
                  <a href="/about-us/our-presence">
                    Our Presence
                  </a>
                </li>

                <li>
                  <a href="/about-us/csr-sustainability">
                    CSR & Sustainability
                  </a>
                </li>

                <li>
                  <a href="/about-us/trade-participations-honours">
                    Trade Participations & Honour
                  </a>
                </li>

                <li>
                  <a href="/contact-us">
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>

            <div className="sitemap-block">
              <h3>
                <FaIndustry />
                <a href="/bentonite-minerals"> Bentonite Minerals </a>
              </h3>

              <ul>
                {bentoniteDropdown.map((item,i)=>(
                  <li><a href={`bentonite-minerals/${item.url}`}>{item.title}</a></li>
                ))}
              </ul>
            </div>

          </div>

          {/* COLUMN 2 */}
          <div className="sitemap-column">

            <div className="sitemap-block">
              <h3>
                <FaIndustry />
                <a href="/industrial-minerals">   Industrial Minerals</a>
              </h3>

             <ul>
                {industrialMinerals.map((item,i)=>(
                  <li><a href={`bentonite-minerals/${item.url}`}>{item.cardTitle}</a></li>
                ))}
              </ul>
            </div>

            <div className="sitemap-block">
              <h3>
                <FaGlobe />
                Global Presence
              </h3>

              <ul>
              <li>
  <a href="/vietnam">Vietnam</a>

  <ul className="second-list">

  <li>
      <a href="/vietnam/bentonite-powder-exporter-vietnam">
       Bentonite Powder Exporter
      </a>
    </li>

    <li>
      <a href="/vietnam/bentonite-granules-exporter-vietnam">
     Bentonite Granules Exporter
      </a>
    </li>

    <li>
      <a href="/vietnam/api-bentonite-powder-exporter-vietnam">
     API Bentonite Powder Exporter
      </a>
    </li>

    <li>
      <a href="/vietnam/piling-bentonite-exporter-vietnam">
        Pilling Bentonite Exporter
      </a>
    </li>
    <li>
      <a href="/vietnam/cat-litter-exporter-vietnam">
        Cat Litter Exporter
      </a>
    </li>

  </ul>
</li>

                <li><a href="/thailand">Thailand</a>
                <ul className="second-list">

   <li>
      <a href="/thailand/bentonite-powder-exporter-thailand">
       Bentonite Powder Exporter
      </a>
    </li>

    <li>
      <a href="/thailand/bentonite-granules-exporter-thailand">
     Bentonite Granules Exporter
      </a>
    </li>

    <li>
      <a href="/thailand/api-bentonite-powder-exporter-thailand">
     API Bentonite Powder Exporter
      </a>
    </li>

    <li>
      <a href="/thailand/piling-bentonite-exporter-thailand">
        Pilling Bentonite Exporter
      </a>
    </li>
    <li>
      <a href="/thailand/cat-litter-exporter-thailand">
        Cat Litter Exporter
      </a>
    </li>
  </ul></li>
                <li><a href="/malaysia">Malaysia</a>
                <ul className="second-list">

    <li>
      <a href="/malaysia/bentonite-powder-exporter-malaysia">
       Bentonite Powder Exporter
      </a>
    </li>

    <li>
      <a href="/malaysia/bentonite-granules-exporter-malaysia">
     Bentonite Granules Exporter
      </a>
    </li>

    <li>
      <a href="/malaysia/api-bentonite-powder-exporter-malaysia">
     API Bentonite Powder Exporter
      </a>
    </li>

    <li>
      <a href="/malaysia/piling-bentonite-exporter-malaysia">
        Pilling Bentonite Exporter
      </a>
    </li>
    <li>
      <a href="/malaysia/cat-litter-exporter-malaysia">
        Cat Litter Exporter
      </a>
    </li>

  </ul></li>
                <li><a href="/philippines">Philippines</a>
                <ul className="second-list">

   <li>
      <a href="/philippines/bentonite-powder-exporter-philippines">
       Bentonite Powder Exporter
      </a>
    </li>

    <li>
      <a href="/philippines/bentonite-granules-exporter-philippines">
     Bentonite Granules Exporter
      </a>
    </li>

    <li>
      <a href="/philippines/api-bentonite-powder-exporter-philippines">
     API Bentonite Powder Exporter
      </a>
    </li>

    <li>
      <a href="/philippines/piling-bentonite-exporter-philippines">
        Pilling Bentonite Exporter
      </a>
    </li>
    <li>
      <a href="/philippines/cat-litter-exporter-philippines">
        Cat Litter Exporter
      </a>
    </li>

  </ul></li>
                
                <li><a href="/singapore">Singapore</a>
                <ul className="second-list">

   <li>
      <a href="/singapore/bentonite-powder-exporter-singapore">
       Bentonite Powder Exporter
      </a>
    </li>

    <li>
      <a href="/singapore/bentonite-granules-exporter-singapore">
     Bentonite Granules Exporter
      </a>
    </li>

    <li>
      <a href="/singapore/api-bentonite-powder-exporter-singapore">
     API Bentonite Powder Exporter
      </a>
    </li>

    <li>
      <a href="/singapore/piling-bentonite-exporter-singapore">
        Pilling Bentonite Exporter
      </a>
    </li>
    <li>
      <a href="/singapore/cat-litter-exporter-singapore">
        Cat Litter Exporter
      </a>
    </li>

  </ul>
                </li>
              </ul>
            </div>

            <div className="sitemap-block">
              <h3>
                <FaNewspaper />
                 <a href="/blogs">  Blogs </a>
              </h3>

               <ul>
                {blogs.map((item,i)=>(
                  <li><a href={`blogs/${item.url}`}>{item.title}</a></li>
                ))}
              </ul>

            </div>

            <div className="sitemap-block">
              <h3>
                <FaFileAlt />
                Legal
              </h3>

              <ul>
                <li><a href="/privacy-policy">Privacy Policy</a></li>
                <li><a href="/sitemap">Sitemap</a></li>
              </ul>
            </div>

          </div>

        </div>

      </div>

    </section>
        </>
    )
}
export default Sitemap;